module.exports = __webpack_public_path__ + "static/media/bouygues.f1f15476.png";